
<input type="number" [(ngModel)]="price" class='lcd price-input' />
<div class="button-container">
	<button class="button-save" (click)="onSaveClick()">Save</button>
</div>
